import { usePermissions } from 'hooks/usePermissions';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider } from 'react-admin';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { Card, CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { TextField } from 'shared/mui/Fields';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { CopyToClipboardTextField } from 'shared/react-admin/Fields';
import { Mapping } from 'types/embedded/gatewayRule';
import { Permission } from 'types/embedded/permission';

type Props = {
  mapping: Mapping;
  onSubmitDialog: () => void;
} & DialogProps;

export const GatewayRuleMappingDescriptionShowDialog: React.FC<Props> = ({
  onClose,
  open,
  mapping,
  onSubmitDialog,
}) => {
  const translate = useTypedTranslate();
  const { hasResourcePermissions } = usePermissions();

  return (
    <Dialog onClose={onClose} open={open}>
      <RecordContextProvider value={mapping}>
        <Card sx={{ width: '600px' }}>
          <CardHeader
            appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
            title={translate('app.gatewayRules.mappingDetails')}
            titleSize="smallBold"
          />
          <CardContent>
            <TextField
              disabled
              fullWidth
              label={translate('app.table.method')}
              rows={4}
              size="small"
              sx={{ marginBottom: '24px' }}
              value={mapping.method.name}
              variant="outlined"
            />
            <CopyToClipboardTextField
              label={translate('app.table.description')}
              size="small"
              source="description"
            />
          </CardContent>
          <CardActionsButtons
            rightActionsSlot={[
              <CancelButton
                key="cancel-button"
                label={translate('app.buttons.close')}
                onClick={onClose}
                variant="outlined"
              />,
              hasResourcePermissions('mappings', [Permission.Full, Permission.Update]) && (
                <Button
                  key="apply-button"
                  label={translate('app.buttons.edit')}
                  onClick={() => {
                    onClose();
                    onSubmitDialog();
                  }}
                  type="submit"
                  variant="contained"
                />
              ),
            ]}
          />
        </Card>
      </RecordContextProvider>
    </Dialog>
  );
};
